module.exports = __webpack_public_path__ + "img/east-timor.c28ddc89.svg";